import { Button, Form, Modal } from "antd";
import { PaymentDetails } from "../../../shared/payment/payment-details";
import { useState } from "react";
import { Country } from "../../../../types/country";
import { ApplicantUserUpdatePaymentInstrumentInput } from "../../../../generated";

export interface UpdateCardModalProps {
  onCardUpdate: (
    data: ApplicantUserUpdatePaymentInstrumentInput
  ) => Promise<void>;
  cyberSourcePublicKey: string;
  isOpen: boolean;
  onClose: () => void;
  paymentInstrumentId: string | null | undefined;
  countries: Country[];
}

export const UpdateCardModal: React.FC<UpdateCardModalProps> = (props) => {
  const [generatePaymentToken, setGeneratePaymentToken] = useState<
    (() => Promise<void>) | undefined
  >();
  const [submitting, setSubmitting] = useState(false);
  const [paymentDetailsKey, setPaymentDetailsKey] = useState(0);
  const [form] = Form.useForm();

  const onSubmit = async () => {
    setSubmitting(true);
    const paymentToken = form.getFieldValue("paymentInstrumentToken");
    if (!paymentToken && generatePaymentToken) {
      await generatePaymentToken();
    }
    if (!props.paymentInstrumentId) {
      console.error("Payment instrument ID is required");
      return;
    }

    form
      .validateFields()
      .then(async (values) => {
        if (!values.paymentInstrumentToken) {
          console.error("Payment instrument token is required");
          return;
        }

        try {
          const input = {
            paymentInstrumentId: props.paymentInstrumentId as string,
            paymentInstrument: {
              billingAddressLine1: values.address,
              billingAddressLine2: values.billingAddressLine2,
              billingCity: values.city,
              billingState: values.state,
              billingCountry: values.country,
              billingPostalCode: values.billingPostalCode,
              billingEmail: values.billingEmail,
              billingFirstName: values.billingFirstName,
              billingLastName: values.billingLastName,
              paymentToken: values.paymentInstrumentToken,
            },
          };
          await props.onCardUpdate(input);
          form.resetFields();
          setPaymentDetailsKey((prev) => prev + 1);
          props.onClose();
        } catch (error) {
          console.error("Error updating card", error);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onFormClose = () => {
    setPaymentDetailsKey((prev) => prev + 1);
    form.resetFields();
    props.onClose();
  }
  return (
    <Modal
      open={props.isOpen}
      onCancel={onFormClose}
      maskClosable={false}
      title="Update Card Information"
      footer={() => (
        <div className="flex w-full justify-end gap-2">
          <Button onClick={onFormClose}>Cancel</Button>
          <Button type="primary" onClick={onSubmit} loading={submitting}>
            Update Card
          </Button>
        </div>
      )}
    >
      <PaymentDetails
        key={paymentDetailsKey}
        countries={props.countries}
        cyberSourcePublicKey={props.cyberSourcePublicKey}
        form={form}
        setGeneratePaymentToken={setGeneratePaymentToken}
        displayTitle={false}
      />
    </Modal>
  );
};
